// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

import wixLocation from 'wix-location';

$w.onReady(function () {
	// Write your JavaScript here

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
	// Force iFrame to take in dynamic parameter for Arlo course page.
	let queryArray = Object.entries(wixLocation.query);
	let queryString = queryArray.map( function( item ){ return item.join( "=" )  } ).join("&");
	$w("#html1").src = $w("#html1").src + "?" + queryString;
});
